import { render, staticRenderFns } from "./AttributionsSession.vue?vue&type=template&id=7a80b410"
import script from "./AttributionsSession.vue?vue&type=script&lang=js"
export * from "./AttributionsSession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports